import { FilterProps } from '../types';

interface UseCommonFilterLogicProps {
  filters: FilterProps[];
}

const useCommonFilterLogic = ({ filters }: UseCommonFilterLogicProps) => {
  const clearAllFilters = () => {
    filters.forEach((filter) => (filter?.cleanFilter ? filter?.cleanFilter() : null));
  };

  return { clearAllFilters };
};

export default useCommonFilterLogic;
